var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrapper"},[(!_vm.$route.meta.hideSidebar)?_c('sidebar'):_vm._e(),_c('div',{staticClass:"con-wrapper"},[(!_vm.$route.meta.hideHeader)?_c('header-Top'):_vm._e(),(!_vm.$route.meta.hideBread)?_c('bread-crumb'):_vm._e(),(_vm.$store.state.busId)?_c('app-Main',{attrs:{"id":"vipMainCon"}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }